<template>
  <div class="rating-star-comp" :class="{'pointer-none': !changeable}">
    <template v-if="!single">
      <div 
        v-for="index in 5"
        :key="`star-${index}`" 
        class="star" 
        :class="{'active': index <= rating, 'active-half': (index > rating) && (index - 1 < rating)}"
        @click="selectRating(index)"
      >
        <i class="fas fa-star star-active"/>
        <i class="fas fa-star star-disabled"/>
      </div>
    </template>
    <template v-else>
      <p class="d-flex align-items-center mb-0">
        <span><i class="fas fa-star mr-gd-half" :class="{'active': rating > 0, 'disabled': rating == 0 }" /></span>
        <span>{{ ratingText }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    rating: {
      type: [String, Number], // 1-5
      default: 0,
    },
    ratingCount: {
      type: [String, Number],
      default: 0,
    },
    single: {
      type: Boolean,
      default: false,
    },
    changeable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localRating: 0,
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "designIframe/metadata/siteActiveLanguage",
    }),
    ratingAvg() {
      const rating = Number(this.rating);
      return rating % 1 === 0 ? rating + '.0' : rating;
    },
    ratingText() {
      return this.ratingCount > 0 
                ? `${this.ratingAvg} / 5 (${this.ratingCount} ${this.$t('website.productReview.lblReviews', this.languageUse)})` 
                : this.$t('website.productReview.lblNotReview', this.languageUse)
    },
  },
  watch: {
    rating: {
      handler() {
        this.localRating = this.rating
      }
    }
  },
  mounted() {
    this.localRating = this.rating
  },
  methods: {
    selectRating(rating) {
      this.localRating = rating;
      this.$emit('change', rating)
    },
  },
};
</script>

<style lang="scss">
.rating-star-comp {
  .fa-star {
    font-size: 14px;
    &.active {
      color: #F8CF5B;
    }
    &.disabled {
      color: #D5D5D5;
    }
  }

  display: flex;
  align-items: center;
  gap: 2px;
  .star {
    position: relative;
    width: 12px;
    height: 12px;
    cursor: pointer;
    i {
      font-size: 11px;
    }
    svg {
      width: 12px;
      height: 12px;
    }
    &.active {
      .star-active {
        z-index: 1;
      }
    }
    &.active-half {
      .star-active {
        z-index: 1;
        width: 50%;
        overflow: hidden;
      }
    }
    .star-active {
      color: #F8CF5B !important;
      position: absolute;
      top: 0;
      left: 0;
    }
    .star-disabled {
      color: #D5D5D5 !important;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
